import httpClient from './httpClient'

const IPRangeListTargetingApi = {
  async fetchIPRangeListTargetingList(params) {
    try {
      const res = await httpClient.get('/targeting/ip_range_list', {
        paramas: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchIPRangeListTargetingListAdvertiser(params, advertiserId) {
    try {
      const res = await httpClient.get(
        `/advertiser/${advertiserId}/managed/targeting/ip_range_list`,
        {
          paramas: params,
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchIPRangeListTargeting(params, ipRangeListId) {
    try {
      const res = await httpClient.get(
        `/targeting/ip_range_list/${ipRangeListId}/item`,
        {
          params: params,
        },
      )
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
}

export default IPRangeListTargetingApi
